import client from '../../apollo';
import { gql } from '@apollo/client'
import apiClient from 'ps-components/lib/apiClient';
import { hideSlideout } from 'ps-components/Slideout/SlideoutReducer';

export const CLEAR_SELECTED_JOB = 'CLEAR_SELECTED_JOB';
export const GET_JOB_MARKET_ELEMENTS = 'GET_JOB_MARKET_ELEMENTS';
export const GET_MARKET_ELEMENTS = 'GET_MARKET_ELEMENTS';
export const JOB_RANGE = 'JOB_RANGE';
export const SET_SELECTED_JOB = 'SET_SELECTED_JOB';
export const UPDATE_VALUES = 'UPDATE_VALUES';

export function clearSelectedJob() {
  return { type: CLEAR_SELECTED_JOB };
}

export function getJobByID(id) {
  return async dispatch => {
    if (!id) console.log('There was no id provided');

    try {
      const query = gql`
        query orgJob($id: ID!) {
          orgJob(id: $id) {
            code
            codeKey
            id
            title
          }
        }
      `;

      const { data } = await client.query({
        query,
        variables: { id: id },
        fetchPolicy: 'network-only'
      });

      dispatch({ type: SET_SELECTED_JOB, data: data.orgJob });
    } catch (error) {
      console.log(error);
    }
  };
}

export function getJobData(selectedJob) {
  return async dispatch => {
    const marketElements = await apiClient.apiPost('/api/hris/job-ranges/getJobMarketElements', {
      orgJobCode: selectedJob.code,
      orgJobCodeKey: selectedJob.codeKey
    });

    const jobRange = await apiClient.apiPost('/api/hris/job-ranges/getJobRange', {
      orgJobCode: selectedJob.code,
      orgJobCodeKey: selectedJob.codeKey
    });

    dispatch({
      type: JOB_RANGE,
      data: jobRange.data
    });

    dispatch({
      type: GET_JOB_MARKET_ELEMENTS,
      data: marketElements.data
    });
  };
}

export function getMarketElements() {
  return async dispatch => {
    const response = await apiClient.apiGet('/api/hris/job-ranges/getMarketElements');

    dispatch({
      type: GET_MARKET_ELEMENTS,
      data: response.data
    });
  };
}

export function updateJobRange(selectedJob, newState, roundTo) {
  const maxSalary = (newState.maxPct / 100) * newState.maxValue,
    midSalary = (newState.midPct / 100) * newState.midValue,
    minSalary = (newState.minPct / 100) * newState.minValue;

  return async dispatch => {
    const data = {
      orgJobCode: selectedJob.code,
      orgJobCodeKey: selectedJob.codeKey,
      salaryRange: {
        max: Math.round(maxSalary / roundTo) * roundTo,
        mid: Math.round(midSalary / roundTo) * roundTo,
        min: Math.round(minSalary / roundTo) * roundTo
      },
      salaryRangePct: {
        max: newState.maxPct,
        mid: newState.midPct,
        min: newState.minPct
      },
      salaryRangePctElements: {
        max: newState.maxElement,
        mid: newState.midElement,
        min: newState.minElement
      },
      roundTo: roundTo
    };

    const marketElements = await apiClient.apiPost('/api/hris/job-ranges/updateJobRange', data);
    dispatch({ type: UPDATE_VALUES, data: data });
    dispatch(hideSlideout());
  };
}
